import React, { useContext } from "react";
import { DrawModeChangeEvent } from "@mapbox/mapbox-gl-draw";

import { SelectIcon } from "fond/svg_icons";

import { MapContext } from "../MapProvider";

import { IButtonProps } from "./Toolbar";
import ToolbarToggleButton from "./ToolbarToggleButton";

const SelectButton: React.FC<IButtonProps> = ({ icon, title = "Select feature" }) => {
  const { map, drawControl } = useContext(MapContext);

  const handleOnClick = () => {
    drawControl.current?.changeMode("simple_select");
    map?.fire("draw.modechange", { type: "draw.modechange", mode: "simple_select" } as DrawModeChangeEvent);
  };

  return (
    <ToolbarToggleButton title={title} value="simple_select" onClick={handleOnClick} data-testid="toolbar-select-button">
      {icon || <SelectIcon />}
    </ToolbarToggleButton>
  );
};

export default SelectButton;
